import { QueryString, isPlainObject } from "@grandvisionhq/utils";
import { EmptyConsent } from "../../types.js";
import { shouldBypassConsent } from "../../utils/utils/debug.js";
import { BypassProvider } from "./bypass-provider.js";
const OneTrustConsentMap = {
  C0001: "required",
  C0002: "analytics",
  C0003: "functional",
  C0004: "marketing",
  C0005: "social"
};
const isCookieCategoryEnabled = (category, consentResult) => consentResult ? consentResult.has(category) : false;
const isOneTrustCookie = (data) => isPlainObject(data) && "groups" in data;
function getConsentResult(cookies) {
  if (shouldBypassConsent()) {
    return BypassProvider();
  }
  const consentRawData = cookies?.OptanonConsent || "";
  if (!consentRawData) {
    return EmptyConsent;
  }
  const parsedValues = QueryString.parse(consentRawData);
  if (!isOneTrustCookie(parsedValues)) {
    return EmptyConsent;
  }
  return new Set(
    parsedValues.groups.split(",").map((pair) => pair.split(":")).filter(([, value]) => value && +value).map(([key]) => OneTrustConsentMap[key])
    // => [ 'required', ... ]
  );
}
const OneTrustProvider = (cookies) => {
  return getConsentResult(cookies);
};
export {
  OneTrustProvider,
  getConsentResult,
  isCookieCategoryEnabled
};
//# sourceMappingURL=onetrust-provider.js.map
